import { useState } from 'react';
import { Annotation } from '../../types/annotation';

interface UseAnnotationEditProps {
  annotations: Annotation[];
  onUpdateAnnotation: (annotation: Annotation) => void;
}

export function useAnnotationEdit({ annotations, onUpdateAnnotation }: UseAnnotationEditProps) {
  const [editingAnnotation, setEditingAnnotation] = useState<Annotation | null>(null);

  const handleAnnotationClick = (id: string) => {
    const annotation = annotations.find(a => a.id === id);
    if (annotation) {
      setEditingAnnotation(annotation);
    }
  };

  const handleEditClose = () => {
    setEditingAnnotation(null);
  };

  const handleEditSave = (updatedAnnotation: Annotation) => {
    onUpdateAnnotation(updatedAnnotation);
    setEditingAnnotation(null);
  };

  return {
    editingAnnotation,
    handleAnnotationClick,
    handleEditClose,
    handleEditSave
  };
}